import { Layers, Object3D } from 'three';

import { DOLLHOUSE_LAYER_INTERACTIVE } from '@spazious/dollhouse-three';

import { createStoreContext } from '../../utils/index.js';

export interface SelectionApi {
  selected: Object3D[];
  select: (selected: Object3D[]) => void;
  enabled: boolean;
  layers: Layers;
}

const createLayers = (layer: number) => {
  const layers = new Layers();
  layers.set(layer);
  return layers;
};
const storeContext = createStoreContext<SelectionApi>((set) => ({
  selected: [],
  select: (selected: Object3D[]) => set({ selected }),
  enabled: true,
  layers: createLayers(DOLLHOUSE_LAYER_INTERACTIVE),
}));

export const selectionStore = storeContext.store;
export const useSelection = storeContext.useStore;
export const useSelectionStore = storeContext.useStoreApi;
export const SelectionContext = storeContext.StoreContext;
export const SelectionProvider = storeContext.StoreProvider;
